import { Controller, useFormContext } from 'react-hook-form';

import { FormControl, FormControlProps } from '../ui/FormControl';
import { Select, SelectProps } from '../ui/Select';

export type SelectFieldProps = FormControlProps &
  SelectProps & {
    options: Array<{
      label: string;
      value: string | number;
    }>;
    placeholder?: string;
  };

const SelectField = (props: SelectFieldProps) => {
  const { control } = useFormContext();
  const { name, onChange, label, caption, detail, isDisabled, isRequired, placeholder, options, ...fieldProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { value, onChange: onChangeHookForm, onBlur },
        formState: { isSubmitted },
        fieldState: { isTouched, error },
      }) => {
        const hasError = error && (isTouched || isSubmitted);

        return (
          <FormControl
            name={name}
            label={label}
            detail={detail}
            caption={hasError ? error.message : caption}
            isDisabled={isDisabled}
            isInvalid={hasError}
          >
            <Select
              {...fieldProps}
              name={name}
              id={name}
              value={value || ''}
              onChange={(e) => {
                onChangeHookForm(e);

                if (onChange) onChange(e);
              }}
              onBlur={onBlur}
              isInvalid={hasError}
              isRequired={isRequired}
              disabled={isDisabled}
            >
              {placeholder && (
                <option
                  value=""
                  disabled
                >
                  {placeholder}
                </option>
              )}
              {options.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              ))}
            </Select>
          </FormControl>
        );
      }}
    />
  );
};

SelectField.displayName = 'SelectField';

export { SelectField };
